export enum LivePagePreviewView {
    Desktop = "desktop",
    Mobile = "mobile",
}